import { render, staticRenderFns } from "./CustomersAssetsSearch.vue?vue&type=template&id=72d1a13e&scoped=true&"
import script from "./CustomersAssetsSearch.vue?vue&type=script&lang=js&"
export * from "./CustomersAssetsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d1a13e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
